import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Divider, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useSelector, useDispatch } from 'react-redux';

import UpdateproductActionModalContainer from './UpdateproductActionModalContainer';
import {setProductUpdateproductModal} from '../../../../store/slice/PharmaSlice';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  width: { lg: '95%', xs: '95%' },
  height: { lg: '95%', xs: '95%' },
  borderRadius: 3,
  //overflow:'scroll',
  p: 1,
  backgroundColor:'secondary.lighter',
};

export default function UpdateproductActionModal() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);;
  const {updateproductModalOpen, productObj} = useSelector((state)=>state.pharmaslice.productDashboard);
  const {pharmaorderObj} = useSelector((state)=>state.pharmaslice.pharmaorderDashboard);

  useEffect(()=>{
  },[updateproductModalOpen])

  const handleModalClose=()=>{
    handleClose();
    dispatch(setProductUpdateproductModal(false));
  }
  return (
    <Modal
       open={updateproductModalOpen===undefined?false:updateproductModalOpen}
      onClose={handleModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} >

        <Grid container direction="row" justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant="h5"  >
              # {pharmaorderObj.id} - Update Product
            </Typography>
          </Grid>
          <Grid item>
            <CloseIcon sx={{ cursor: "pointer" }} onClick={() => handleModalClose()} />
          </Grid>
        </Grid>
        <Grid item>
          <Divider />
          <Box height="20px"></Box>
        </Grid>
        <Grid item>
            < UpdateproductActionModalContainer/>
        </Grid>

      </Box>
    </Modal>
  );
}